import React, {
  ComponentType,
  useEffect,
  useRef,
  useState,
  useMemo,
} from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import styles from '../../components/Document/styles.module.css';
import { SlidingPane } from '../../components/Page/SlidingPane';
import { SlidingPaneAddNew } from '../../components/Page/SlidingPaneAddNew';
import Table from '../../components/Table/NewTable';
import { useStateContext } from '../../hooks/useStateContext';
import api from '../../services/api';
import { LoadingPage } from '../LoadingPage/LoadingPage';
import { activityGroup } from '../../schema/activityGroup';
import { useParams } from 'react-router-dom';
import { SocketProvider } from '../../contexts/SocketContext';
import { ChangeTabConfirmDialog } from '../../components/SidePane/ChangeTabConfirmDialog';

export const ActivityGroups: ComponentType = () => {
  const { user, isMobile } = useStateContext();
  const { id } = useParams();

  const [loading, setLoading] = useState<any>({
    table: false,
  });
  const [view, setView] = useState<any>(undefined);
  const { viewPeriod } = useStateContext();
  const [width, setWidth] = useState(40);
  const [selectedRow, setSelectedRow] = useState<any>(undefined);

  const schema = useMemo(() => {
    return activityGroup;
  }, []);
  const [openedPanel, setOpenedPanel] = useState(false);
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({
    schema: schema,
    row: {},
  });
  const [openedSlidingPaneAddNew, setOpenedSlidingPaneAddNew] = useState<any>({
    schema: schema,
    row: {},
  });
  const [fullWidth, setFullWidth] = useState(!!id);
  const [columnMask, setColumnMask] = useState(undefined);
  const [isLocked, setIsLocked] = useState(false);

  const [unsavedModification, setUnsavedModification] = useState(false);
  const [
    openModificationConfirmDialog,
    setOpenModificationConfirmDialog,
  ] = useState<any>(false);

  const searchParams = useMemo(() => {
    const searchParams = new URLSearchParams();
    return searchParams;
  }, [viewPeriod]);

  useEffect(() => {
    setLoading({ ...loading, ['table']: true });
    api.get(`/users/${user.id}/views/activity-groups`).then((res: any) => {
      setLoading({ ...loading, ['table']: false });
      setView(res);

      const columnMaskObj = res.columns.reduce((acc: any, column: any) => {
        return {
          ...acc,
          [column.name]: true,
        };
      }, {});
      columnMaskObj[`__tree_data_group__`] = false;
      setColumnMask(columnMaskObj);
    });
  }, []);

  const panelRef: any = useRef(null);

  const handlePanelWidth = (fullWidth: boolean) => {
    console.log('handlePanelWidth', fullWidth);

    setFullWidth(fullWidth);
    if (panelRef.current) {
      panelRef.current.resize(fullWidth ? 100 : width);
    }
  };

  const openSlidingPaneHandle = (
    row: any,
    openedSchema: any,
    newEntity?: boolean,
    openInFull?: boolean,
    isLocked?: any
  ) => {
    if (isLocked !== undefined) {
      setIsLocked(isLocked);
    }

    if (newEntity) {
      setOpenedSlidingPaneAddNew({
        schema: openedSchema,
        row,
      });
      handlePanelWidth(!!openInFull);
      return;
    }

    if (row) {
      if (!openedPanel) {
        setOpenedPanel(true);
      }
    } else {
      setOpenedPanel(false);
    }

    setOpenedSlidingPane({
      schema: openedSchema,
      row,
    });

    handlePanelWidth(!!openInFull);
  };

  useEffect(() => {
    document.title = `Zoe - Activity Groups`;
  }, []);

  useEffect(() => {
    if (id) {
      handlePanelWidth(true);
      schema.client.readOne(parseInt(id), searchParams).then((res: any) => {
        setOpenedSlidingPane({
          schema: schema,
          row: res,
        });
      });
    }
  }, [id]);

  const mainFunctionRef: any = useRef(null);

  const handleRefreshMainTableData = () => {
    mainFunctionRef.current();
  };

  const [lastForceFetchedStamp, setLastForceFetchedStamp] = useState<
    number | undefined
  >(undefined);

  const [removeInterval, setRemoveInterval] = useState(false);
  const slidingPaneRef = useRef<any>(null);

  if (loading.table) {
    return <LoadingPage />;
  }

  if (!schema || !view) {
    return <LoadingPage />;
  }

  const handleKickEvent = (data: any) => {
    console.log('Kick event received in parent component:', data);

    if (data.table === schema?.viewTable) {
      if (slidingPaneRef.current) {
        slidingPaneRef.current.onSubmit();
      }
    }
  };

  const handleSelectNewRow = (
    row: any,
    openedSchema: any,
    newEntity?: boolean,
    openInFull?: boolean,
    isLocked?: any,
    modification?: any
  ) => {
    if (modification) {
      setOpenModificationConfirmDialog({
        row: row,
        openedSchema: openedSchema,
        newEntity: newEntity,
        openInFull: openInFull,
        isLocked: isLocked,
      });
    } else {
      openSlidingPaneHandle(row, schema, false, openInFull, isLocked);
    }
  };

  return (
    <>
      <SocketProvider schema={schema} onKick={handleKickEvent}>
        {isMobile ? (
          <>
            <Table
              setFunctionRef={(ref: any) => (mainFunctionRef.current = ref)}
              searchParams={searchParams}
              schema={schema}
              columnMask={columnMask}
              onRowSelected={setSelectedRow}
              isView={false}
              viewId={view.id}
              pins={view?.pins}
              selectedRowId={selectedRow}
              currentEditedRow={openedSlidingPane}
              setCurrentEditedRow={(
                row: any,
                openInFull?: boolean,
                isLocked?: any
              ) => {
                handleSelectNewRow(
                  row,
                  schema,
                  false,
                  openInFull,
                  isLocked,
                  unsavedModification
                );
                // openSlidingPaneHandle(row, schema, false, openInFull, isLocked);
              }}
              setCurrentAddNewRow={(row: any) => {
                openSlidingPaneHandle(row, schema, true);
              }}
              hasSlidingPane={true}
              lastForceFetchedStamp={lastForceFetchedStamp}
              openedPanel={openedPanel}
            />
          </>
        ) : (
          <>
            <PanelGroup direction="horizontal">
              <Panel>
                <PanelGroup key={1} autoSaveId="example" direction="vertical">
                  <Panel
                    className={`${selectedRow ? '' : 'full-height'} ${
                      styles.Panel
                    }`}
                    collapsible={true}
                    defaultSize={100}
                    order={1}
                  >
                    <Table
                      setFunctionRef={(ref: any) =>
                        (mainFunctionRef.current = ref)
                      }
                      searchParams={searchParams}
                      schema={schema}
                      columnMask={columnMask}
                      onRowSelected={setSelectedRow}
                      isView={false}
                      viewId={view.id}
                      pins={view?.pins}
                      selectedRowId={selectedRow}
                      currentEditedRow={openedSlidingPane}
                      setCurrentEditedRow={(
                        row: any,
                        openInFull?: boolean,
                        isLocked?: any
                      ) => {
                        handleSelectNewRow(
                          row,
                          schema,
                          false,
                          openInFull,
                          isLocked,
                          unsavedModification
                        );
                        // openSlidingPaneHandle(row, schema, false, openInFull, isLocked);
                      }}
                      setCurrentAddNewRow={(row: any) => {
                        openSlidingPaneHandle(row, schema, true);
                      }}
                      hasSlidingPane={true}
                      lastForceFetchedStamp={lastForceFetchedStamp}
                      openedPanel={openedPanel}
                    />
                  </Panel>
                </PanelGroup>
              </Panel>
              {openedSlidingPane?.row?.id && (
                <>
                  <PanelResizeHandle
                    className={`${styles.ResizeHandleOuter} bg-[#ddd]`}
                  >
                    <div className={styles.ResizeHandleInner}>
                      <svg className={styles.Icon} viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z"
                        />
                      </svg>
                    </div>
                  </PanelResizeHandle>
                  <Panel
                    className={`${styles.Panel}`}
                    collapsible={false}
                    minSize={20}
                    defaultSize={fullWidth ? 100 : 40}
                    ref={panelRef}
                  >
                    <SlidingPane
                      ref={slidingPaneRef}
                      setFullWidthProp={(value) => {
                        handlePanelWidth(value);
                      }}
                      fullWidth={fullWidth}
                      schema={openedSlidingPane?.schema}
                      id={
                        openedSlidingPane?.hasOwnPane
                          ? undefined
                          : openedSlidingPane?.row?.id
                      }
                      onSubmit={() => {
                        handleRefreshMainTableData();
                      }}
                      forcedRefresh={() => {
                        handleRefreshMainTableData();
                      }}
                      propertiesFromTable={
                        openedSlidingPane?.row ? openedSlidingPane?.row : {}
                      }
                      onClose={(value) => {
                        schema.client
                          .deleteLock(value?.id, {
                            schema: JSON.stringify(
                              openedSlidingPane?.schema.client
                            ),
                            view_table: openedSlidingPane?.schema.viewTable,
                          })
                          .then((result: any) => {});

                        setRemoveInterval(true);
                        setOpenedSlidingPane({
                          schema: schema,
                          row: {},
                        });
                        setOpenedPanel(false);
                      }}
                      addNewRow={(schema: any, tab: any) => {
                        openSlidingPaneHandle(
                          {
                            id: 'new',
                            group: openedSlidingPane?.row,
                          },
                          schema,
                          true,
                          false
                        );
                      }}
                      refreshMainTable={() => {
                        handleRefreshMainTableData();
                      }}
                      isLocked={isLocked}
                      hasUnsavedModifications={(value: any) => {
                        console.log(`Activity unsaved changes: ${value}`);
                        setUnsavedModification(value);
                      }}
                    />
                  </Panel>
                </>
              )}
            </PanelGroup>
          </>
        )}

        {openedSlidingPaneAddNew?.row?.id && (
          <>
            <SlidingPaneAddNew
              schema={openedSlidingPaneAddNew?.schema}
              id={
                openedSlidingPaneAddNew?.hasOwnPane
                  ? undefined
                  : openedSlidingPaneAddNew?.row?.id
              }
              onSubmit={() => {
                setOpenedSlidingPaneAddNew({
                  schema: schema,
                  row: {},
                });
                handleRefreshMainTableData();
              }}
              propertiesFromTable={
                openedSlidingPaneAddNew?.row ? openedSlidingPaneAddNew?.row : {}
              }
              onClose={(value) => {
                setOpenedSlidingPaneAddNew({
                  schema: schema,
                  row: {},
                });
              }}
            />
          </>
        )}
      </SocketProvider>
    </>
  );
};
